module.exports = __webpack_public_path__ + "img/mortalin.3c162c21.svg";